import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/caret.svg'


const _hoisted_1 = {
  ref: "onBoardingTextToolRef",
  class: "text-tool-component"
}
const _hoisted_2 = { id: "text-wrap" }
const _hoisted_3 = { id: "selectors-wrap" }
const _hoisted_4 = { class: "flex-container" }
const _hoisted_5 = { class: "currently-selected" }
const _hoisted_6 = {
  key: 0,
  class: "dropDownFont dropDownScroll"
}
const _hoisted_7 = ["value", "onClick"]
const _hoisted_8 = { class: "flex-container" }
const _hoisted_9 = { class: "currently-selected" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "dropDownSize dropDownScroll"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { id: "style-alignment-options" }
const _hoisted_14 = { id: "styles" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { for: "fontWeight" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { for: "fontStyle" }
const _hoisted_19 = { for: "underline" }
const _hoisted_20 = { id: "alignments" }
const _hoisted_21 = { for: "leftAlign" }
const _hoisted_22 = { for: "centerAlign" }
const _hoisted_23 = { for: "rightAlign" }
const _hoisted_24 = { id: "color-inputs" }
const _hoisted_25 = { class: "color-input-container" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Fill", -1)
const _hoisted_27 = { class: "color-input-container" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Border", -1)
const _hoisted_29 = { id: "range-inputs" }
const _hoisted_30 = { class: "range-wrap" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "Border Width", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "range-wrap" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, "Transparency", -1)
const _hoisted_35 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTitle = _resolveComponent("ToolTitle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTitle, { title: _ctx.title }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTextProp($event, 'text'))),
        id: "text-editor",
        name: "text-editor",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentText = $event))
      }, null, 544), [
        [_vModelText, _ctx.currentText]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          id: "font-selector",
          class: _normalizeClass(_ctx.showFonts ? ' bottom-border' : ''),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFonts = !_ctx.showFonts))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.currentFont), 1)
            ]),
            _createElementVNode("img", {
              src: _imports_0,
              class: _normalizeClass(_ctx.showFonts ? 'animCaretDown' : 'animCaretUp')
            }, null, 2)
          ]),
          _createVNode(_Transition, {
            name: "expand",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.showFonts)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFonts, (font, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        value: font,
                        class: "listName",
                        name: "font",
                        onClick: ($event: any) => (_ctx.setTextProp($event, 'fontFamily', font))
                      }, [
                        _createElementVNode("span", {
                          style: _normalizeStyle({ fontFamily: font })
                        }, _toDisplayString(font), 5)
                      ], 8, _hoisted_7))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          id: "size-selector",
          class: _normalizeClass(_ctx.showSizes ? ' bottom-border' : ''),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSizes = !_ctx.showSizes))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "text",
                onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFontSize && _ctx.handleFontSize(...args))),
                value: Math.round(_ctx.pxToPts(_ctx.currentFontSize) * 10) / 10
              }, null, 40, _hoisted_10)
            ]),
            _createElementVNode("img", {
              src: _imports_0,
              class: _normalizeClass(_ctx.showSizes ? 'animCaretDown' : 'animCaretUp')
            }, null, 2)
          ]),
          _createVNode(_Transition, {
            name: "expand",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.showSizes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFontSizes, (size, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx,
                        class: "listName",
                        name: "size",
                        onClick: ($event: any) => (_ctx.setTextProp($event, 'fontSize', size))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(Math.round(_ctx.pxToPts(size) * 10) / 10), 1)
                      ], 8, _hoisted_12))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            style: _normalizeStyle({ opacity: !_ctx.hasBold ? '.4' : '' })
          }, [
            _createElementVNode("input", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setTextProp($event, 'fontWeight'))),
              name: "fontWeight",
              id: "fontWeight",
              type: "checkbox",
              disabled: !_ctx.hasBold
            }, null, 8, _hoisted_15),
            _createElementVNode("label", _hoisted_16, [
              _createVNode(_component_font_awesome_icon, {
                class: "",
                icon: "bold",
                "aria-hidden": "true"
              })
            ])
          ], 4),
          _createElementVNode("div", {
            style: _normalizeStyle({ opacity: !_ctx.hasItalic ? '.4' : '' })
          }, [
            _createElementVNode("input", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setTextProp($event, 'fontStyle'))),
              name: "fontStyle",
              id: "fontStyle",
              type: "checkbox",
              disabled: !_ctx.hasItalic
            }, null, 8, _hoisted_17),
            _createElementVNode("label", _hoisted_18, [
              _createVNode(_component_font_awesome_icon, {
                class: "",
                icon: "italic",
                "aria-hidden": "true"
              })
            ])
          ], 4),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setTextProp($event, 'underline'))),
              name: "underline",
              id: "underline",
              type: "checkbox"
            }),
            _createElementVNode("label", _hoisted_19, [
              _createVNode(_component_font_awesome_icon, {
                class: "",
                icon: "underline",
                "aria-hidden": "true"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setTextProp($event, 'textAlign', 'left'))),
              name: "textAlign",
              id: "leftAlign",
              type: "radio",
              checked: ""
            }),
            _createElementVNode("label", _hoisted_21, [
              _createVNode(_component_font_awesome_icon, {
                class: "",
                icon: "align-left",
                "aria-hidden": "true"
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setTextProp($event, 'textAlign', 'center'))),
              name: "textAlign",
              id: "centerAlign",
              type: "radio"
            }),
            _createElementVNode("label", _hoisted_22, [
              _createVNode(_component_font_awesome_icon, {
                class: "",
                icon: "align-center",
                "aria-hidden": "true"
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("input", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setTextProp($event, 'textAlign', 'right'))),
              name: "textAlign",
              id: "rightAlign",
              type: "radio"
            }),
            _createElementVNode("label", _hoisted_23, [
              _createVNode(_component_font_awesome_icon, {
                class: "",
                icon: "align-right",
                "aria-hidden": "true"
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", {
            id: "fill-circle",
            ref: "fillElement",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleToggleColorPickr && _ctx.handleToggleColorPickr(...args)))
          }, null, 512)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", {
            id: "border-circle",
            ref: "borderElement",
            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleToggleColorPickr && _ctx.handleToggleColorPickr(...args)))
          }, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("input", {
            type: "range",
            min: "0",
            max: "100",
            class: "slider",
            value: _ctx.strokeWidth,
            ref: "strokeWidthRange",
            onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setTextProp($event, 'strokeWidth')))
          }, null, 40, _hoisted_32),
          _createElementVNode("div", null, _toDisplayString(_ctx.strokeWidth / 10) + "px", 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("input", {
            type: "range",
            min: "0",
            max: "100",
            value: _ctx.opacity,
            class: "slider",
            ref: "opacityRange",
            onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setTextProp($event, 'opacity')))
          }, null, 40, _hoisted_35),
          _createElementVNode("div", null, _toDisplayString(_ctx.opacity) + "%", 1)
        ])
      ])
    ])
  ], 512))
}